import axiosClient from "./axiosClient";

export const listarMenus = () => axiosClient.get("/menus").then((r) => r.data);
